// extracted by mini-css-extract-plugin
export var centerText = "_7y-8";
export var container = "_7y-0";
export var doughnutContainer = "_7y-7";
export var legend = "_7y-a";
export var legendItemColorDisplay = "_7y-b";
export var legendItemLabel = "_7y-d";
export var legendItemValue = "_7y-c";
export var lg = "_7y-5";
export var maxWidth = "_7y-9";
export var md = "_7y-4";
export var responsive = "_7y-6";
export var sm = "_7y-3";
export var xs = "_7y-2";
export var xxs = "_7y-1";